import React from 'react';
import { Box, Icon, Text } from '@nimbus-ds/components';
import { InfoCircleIcon } from '@nimbus-ds/icons';
import { DiscountType, PaymentMethodsType } from 'commons/types';
import { useTranslationWithPrefix } from 'commons/utils';
import DiscountInput from './DiscountInput';

interface InterfaceDiscount {
  discounts: DiscountType[];
  setDiscounts: React.Dispatch<React.SetStateAction<DiscountType[]>>;
  setDiscountChanged: React.Dispatch<React.SetStateAction<boolean>>;
  hasActivePromotions: boolean;
}

function BankTransferDiscount({
  discounts,
  setDiscounts,
  setDiscountChanged,
  hasActivePromotions,
}: InterfaceDiscount): JSX.Element {
  const { t } = useTranslationWithPrefix('paymentMethods');

  const bankTransferDiscount = discounts.find(
    (discount) =>
      discount.paymentMethodType === PaymentMethodsType.WireTransfer,
  );

  const updateDiscount = (value: number, paymentMethod: PaymentMethodsType) => {
    const index = discounts.findIndex(
      (method) => method.paymentMethodType === paymentMethod,
    );
    const updatedDiscounts = [...discounts];
    if (index >= 0) {
      updatedDiscounts[index] = {
        paymentMethodType: PaymentMethodsType.WireTransfer,
        percentage: value,
      };
    } else {
      updatedDiscounts.push({
        paymentMethodType: PaymentMethodsType.WireTransfer,
        percentage: value,
      });
    }
    setDiscountChanged(true);
    setDiscounts(updatedDiscounts);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="stretch" gap="4">
      <DiscountInput
        name={PaymentMethodsType.WireTransfer}
        discount={bankTransferDiscount?.percentage || 0}
        updateDiscount={updateDiscount}
        disabled={hasActivePromotions}
      />
      {hasActivePromotions && (
        <Box display="flex" gap="1" alignItems="center">
          <Icon color="danger-textHigh" source={<InfoCircleIcon size={14} />} />
          <Text color="danger-textLow">
            {t('transferDiscountErrorHasActivePromotion')}
          </Text>
        </Box>
      )}
    </Box>
  );
}

export default BankTransferDiscount;
